import React from 'react';

import { ReactComponent as HeaderIcon } from './assets/header-icon.svg';
import { Description } from '../Description/Description';
import { Container, ContainerIcon, ContainerContent } from './Card.styles';
import { DonutInfo } from '../DonutInfo/DonutInfo';
import { ButtonCollaborators } from '../ButtonCollaborators/ButtonCollaborators';
import { BarInfo } from '../BarInfo/BarInfo';

interface CardProps {
	id: string;
	description: string;
	title: string;
	risks: any;
	index: number;
	answerReffered: any;
	answers: any;
	requireAttention: any;
	onChangeInitialTab: () => void;
	sequence: number;
	risk: any;
}

export const Card = ({
	id,
	description,
	title,
	answerReffered,
	answers,
	requireAttention,
	risks,
	sequence,
	risk,
	onChangeInitialTab,
}: CardProps) => {
	return (
		<Container>
			<ContainerIcon>
				<HeaderIcon />
			</ContainerIcon>
			<ContainerContent>
				<Description
					description={description}
					title={title}
					position={sequence}
				/>
				<DonutInfo
					risks={risks}
					risk={risk}
					answerReffered={answerReffered}
					answers={answers}
					requireAttention={requireAttention}
					position={sequence}
				/>
				<BarInfo position={sequence} risks={risks} />
				<ButtonCollaborators onChangeInitialTab={onChangeInitialTab} id={id} />
			</ContainerContent>
		</Container>
	);
};
